import ControlsLeftButtons from './ControlsLeftButtons';
import ControlsFilters from './ControlsFilters';
import { cn } from '@/lib/utils';

const Controls = () => (
  <div className={cn(
    'flex flex-col space-x-3 space-y-3',
    'md:flex-row md:items-end md:justify-between md:space-y-0'
  )}>
    <ControlsFilters />
    <ControlsLeftButtons />
  </div>
);

export default Controls;
